module.exports = __webpack_public_path__ + "static/media/16_blanco.76f31cea.svg";